import { render } from "./FactureXEReportingView.vue?vue&type=template&id=38bddfe2&scoped=true"
import script from "./FactureXEReportingView.vue?vue&type=script&lang=js"
export * from "./FactureXEReportingView.vue?vue&type=script&lang=js"

import "./FactureXEReportingView.vue?vue&type=style&index=0&id=38bddfe2&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bddfe2"]])

export default __exports__